export default "__VITE_ASSET__cphotkQg__"